export default __webpack_public_path__ + "static/media/Ballroll_00197.782dc24b.png";